import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import {
  SalesPortalRestaurantFieldsFragmentDoc,
  SalesPortalSupplierFieldsFragmentDoc,
} from './sales-portal-restaurant-fields.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalSelectedRestaurantDocument = gql`
  query SalesPortalSelectedRestaurant(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    chats(
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        supplier_uuid: { _eq: $supplierUUID }
      }
      limit: 1
    ) {
      on_hold
      uuid
      restaurant_uuid
      supplier_uuid
      restaurant {
        ...SalesPortalRestaurantFields
      }
      supplier {
        ...SalesPortalSupplierFields
      }
    }
  }
  ${SalesPortalRestaurantFieldsFragmentDoc}
  ${SalesPortalSupplierFieldsFragmentDoc}
`;
export function useSalesPortalSelectedRestaurantQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >(SalesPortalSelectedRestaurantDocument, options);
}
export function useSalesPortalSelectedRestaurantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >(SalesPortalSelectedRestaurantDocument, options);
}
export type SalesPortalSelectedRestaurantQueryHookResult = ReturnType<
  typeof useSalesPortalSelectedRestaurantQuery
>;
export type SalesPortalSelectedRestaurantLazyQueryHookResult = ReturnType<
  typeof useSalesPortalSelectedRestaurantLazyQuery
>;
export type SalesPortalSelectedRestaurantQueryResult = Apollo.QueryResult<
  Types.SalesPortalSelectedRestaurantQuery,
  Types.SalesPortalSelectedRestaurantQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalSelectedRestaurantQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalSelectedRestaurantQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >(SalesPortalSelectedRestaurantDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalSelectedRestaurantLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalSelectedRestaurantLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalSelectedRestaurantQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalSelectedRestaurantQuery,
    Types.SalesPortalSelectedRestaurantQueryVariables
  >(SalesPortalSelectedRestaurantDocument, lazyOptions);
}
